import "./DropDown.scss";
import {Lang, useI18n} from "../../../i18n/I18nProvider";

const DropDown = () => {
    const { lang, setLang } = useI18n();

    return (
        <select
            className="DropDownLang"
            name="language"
            id="language"
            value={lang}
            onChange={(e) => setLang(e.target.value as Lang)}
        >
            <option value="ua">Українська</option>
            <option value="en">English</option>
        </select>
    );
};

export default DropDown;
